import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Image,
  TreeSelect,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AiFillDelete } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";

import debounce from "lodash.debounce";

import pageApi from "../api/pageApi";
const Page = (props) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const dispatch = useDispatch();
  const confirm = Modal.confirm;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState();
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [listDeleted, setListDeleted] = useState([]);

  const [inputFilter, setFilter] = useState({
    title: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const [lstPage, setLstPage] = useState([]);

  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getPages();
    form.setFieldsValue(valueForm);
  }, [inputFilter, valueForm]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1,title: e.target.value });
  };

  const getCateDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getPages = () => {
    setLoading(true);
    pageApi.getPages(inputFilter).then((res) => {
      if (res?.results) {
        setLstPage(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      title: inputFilter.title,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Tên trang động",
      dataIndex: "title",
      render: (text) => <h3>{text}</h3>,
    },

    {
      title: "Slug",
      dataIndex: "slug",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/page/edit/` + record.id}>
            <Button
              // onClick={() => showEditModal(record)}
              value="large"
              icon={<EditOutlined />}
            >
              Sửa
            </Button>
          </Link>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deletePage(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
    },
  ];

  const deletePage = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa trang động này không?",
      onOk() {
        pageApi
          .deletePage(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công trang động");
              getPages();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={[24,0]}>
            <Col span={24}>
              <label> Tên trang động</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                defaultValue={inputFilter.name}
                placeholder="Nhập tên trang động..."
                onChange={getCateDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
          </Row>
        </Card>
        <br />
        <Space size={10}>
          <Link to="/page/add">
            <Button type="dashed" size="small">
              <EditOutlined /> &nbsp; Thêm trang động
            </Button>
          </Link>
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstPage}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default Page;
